module.exports = __webpack_public_path__ + "static/media/gladys1.3d6e0cdb.mp3";